/**
 * @generated SignedSource<<7c627e50b86b6ed0e41709e13bcd970d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ABTestDistributionSettingFields_root$data = {
  readonly sources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null> | null;
  };
  readonly " $fragmentType": "ABTestDistributionSettingFields_root";
};
export type ABTestDistributionSettingFields_root = ABTestDistributionSettingFields_root$data;
export type ABTestDistributionSettingFields_root$key = {
  readonly " $data"?: ABTestDistributionSettingFields_root$data;
  readonly " $fragmentSpreads": FragmentRefs<"ABTestDistributionSettingFields_root">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ABTestDistributionSettingFields_root",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SourceConnection",
      "kind": "LinkedField",
      "name": "sources",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SourceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Source",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4949e0ce5cf5a7f72f2d418ec80977d7";

export default node;
